import { render, staticRenderFns } from "./pos-setup.vue?vue&type=template&id=68b089a2&"
import script from "./pos-setup.vue?vue&type=script&lang=js&"
export * from "./pos-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports